export default "__VITE_ASSET__DWqtuLJN__"